import pixBlurredField from '@/components/pix/pixBlurredField.vue';

export default {
  components: {
    pixBlurredField,
  },

  props: {
    shouldBlurConfidentialFields: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    shouldBlur(field) {
      return this.shouldBlurConfidentialFields && field.IsConfidential;
    },
  },
};
